<template>
    <div class="section-offer-day">
		<h2 class="w-black title-offer">{{ title }}</h2>
		<div class="center">
			<related-products-item
				v-for="product in products"
				:currency="currency"
				commerce-home
				:key="product.id"
				:product="product"
				:quantity="quantity"
				@add-quantity="addQuantity($event, true)"
				@sub-quantity="subQuantity($event, true)"
			></related-products-item>
		</div>
	</div>
</template>

<script>
import relatedProductsItem from '@/components/market-place/product-detail/related-products-item';

function addQuantity(row, related) {
	if (related) {
		this.$set(row, 'quantity', row.quantity + 1);
	}
}

function subQuantity(row, related) {
	if (related) {
		this.$set(row, 'quantity', row.quantity - 1);
	}
}

function data() {
	return {
		currency: 'S/',
		relatedProducts: [
			{
				id: 1,
				brandName: 'Alpa',
				name: 'Aceite Alpa',
				price: 18.9,
				quantity: 1,
				unitName: 'Galonera',
				urlImage: '/static/images-new/sections/related-products-1.jpg',
			},
			{
				id: 2,
				brandName: 'Dulfina',
				name: 'Azúcar Dulfina',
				price: 18.9,
				quantity: 1,
				unitName: 'Bolsa 2 Kg',
				urlImage: '/static/images-new/sections/related-products-2.jpg',
			},
			{
				id: 3,
				brandName: 'Costeño',
				name: 'Arroz Extra Costeño',
				price: 18.9,
				quantity: 1,
				unitName: 'Bolsa 5 Kg',
				urlImage: '/static/images-new/sections/related-products-3.jpg',
			},
			{
				id: 4,
				brandName: 'Costeño',
				name: 'Maíz Costeño',
				price: 18.9,
				quantity: 1,
				unitName: 'Bolsa 1 Kg',
				urlImage: '/static/images-new/sections/related-products-4.jpg',
			},
			{
				id: 5,
				brandName: 'Don Vittorio',
				name: 'Spaghetti Vittorio',
				price: 18.9,
				quantity: 1,
				unitName: 'Bolsa 600 gr',
				urlImage: '/static/images-new/sections/related-products-5.jpg',
			},
		],
		quantity: 1,
	};
}
export default {
	name: 'section-offer-day',
	data,
	components: {
		relatedProductsItem,
	},
	methods: {
		addQuantity,
		subQuantity,
	},
	props: {
		products: {
			default: () => [],
			type: Array,
		},
		title: String,
	},
};
</script>

<style lang="scss" scoped>
.title-offer {
	color:color(newwarning);
	margin-bottom: 22px;

	@media (max-width: 936px) {
		text-align: center;
	}
}

.center {
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/market-place/section-offer-day.vue